import appLogger from "../../infra/logger/appLogger";
const discoveryRecommendationsLogger = appLogger.withTag("DiscoveryRecommendations");
/**
 * Maps a payload onto row items, preserving the order the surface returned and
 * stamping each item with the payload's `recommId` so interaction tracking and
 * the "For You" badge keep working downstream.
 */
function mapDiscoveryRecommendationItems(payload) {
    const characters = (payload.recomms ?? []).map((recommendation) => ({
        ...recommendation.values,
        id: recommendation.id,
        recommId: payload.recommId,
    }));
    if (characters.length === 0) {
        return { kind: "empty" };
    }
    return { kind: "success", items: characters, total: characters.length };
}
/**
 * Runs one injected recommendation load and turns it into a row outcome. An
 * empty or failed load is an empty row, never a page error. Aborting the signal
 * resolves as cancelled.
 */
export default async function fetchDiscoveryRecommendations({ signal, userId, loadRecommendations, }) {
    if (signal.aborted) {
        return { kind: "cancelled" };
    }
    try {
        const payload = await loadRecommendations({ userId, signal });
        if (signal.aborted) {
            return { kind: "cancelled" };
        }
        return mapDiscoveryRecommendationItems(payload ?? {});
    }
    catch (recommendationError) {
        if (signal.aborted) {
            return { kind: "cancelled" };
        }
        // An empty row is indistinguishable from a failed one to the renderer, so
        // this log is the only signal that the row degraded rather than returned
        // nothing.
        discoveryRecommendationsLogger.error("Discovery recommendation load failed", { userId, recommendationError });
        return { kind: "empty" };
    }
}
